// Kalena 2026-10-06: for the non-paying clients Doctor's Choice assists -- served
// by email (the star) or under the FL / RI rule (the map marker; see the
// store's assistedNonPaying getter) -- the advisor enrolls a plan only when it
// is both commissionable and enrollable, so the plan card's agent line says one
// thing: Enrollable, or Non-Enrollable. Any other combination is Non-Enrollable.
// Paying, internal, financial-advisor and DPC clients keep the two labels.

// `non_commissionable.states` / `non_enrollable.states` is `true` for every
// state or a list of the states the plan is barred in.
function where (flag) {
    const states = flag?.states
    return Array.isArray(states) && states.length ? states.join(', ') : 'all states'
}

export function assistedEnrollLabel (plan, { commissionable, enrollable }) {
    if (commissionable && enrollable) {
        return { text: 'Enrollable', variant: 'success', title: 'Doctor’s Choice can enroll this client in this plan' }
    }
    const reasons = []
    if (!commissionable) reasons.push(`not commissionable in ${where(plan?.non_commissionable)}`)
    if (!enrollable) reasons.push(`not enrollable in ${where(plan?.non_enrollable)}`)
    return { text: 'Non-Enrollable', variant: 'danger', title: `Doctor’s Choice does not enroll this client in this plan: ${reasons.join(' and ')}` }
}
